import AddMerchantModal from './add-merchant-modal';

export default AddMerchantModal;
